document.addEventListener("DOMContentLoaded", function () {
    const video = document.querySelector("video");
    const button = document.querySelector(".btn-video");
    const buttonImg = document.querySelector(".btn-video img");

    if (!button || !video || !buttonImg) {
        return;
    }

    button.addEventListener("click", function () {
        if (video.paused) {
            video.play();
            buttonImg.src = "imgs/icons/pause.png";
        } else {
            video.pause();
            buttonImg.src = "imgs/icons/play.png";
        }
    });
});

Fancybox.bind("[data-fancybox]", {
    // Your custom options
});

$(document).ready(function () {
    const $slides = $('#customCarousel .carousel-slide');
    let currentSlide = 0;
    const totalSlides = $slides.length;
    let autoplayInterval;
    let isAnimating = false;

    function initializeCarousel() {
        $slides.removeClass('active left right exiting');
        $slides.eq(currentSlide).addClass('active');
        updateSideSlides();
    }

    function updateSideSlides() {
        const nextIndex = (currentSlide + 1) % totalSlides;
        const prevIndex = (currentSlide - 1 + totalSlides) % totalSlides;

        $slides.removeClass('left right');
        $slides.eq(nextIndex).addClass('right');
        $slides.eq(prevIndex).addClass('left');
    }

    function showSlide(index, direction) {
        if (isAnimating || currentSlide === index) return;
        isAnimating = true;

        const $current = $slides.eq(currentSlide);
        const $next = $slides.eq(index);

        // Set up exiting animation
        $current
            .removeClass('active')
            .addClass('exiting')
            .css('transform', direction === 'next' ? 'translateX(-100%)' : 'translateX(100%)');

        // Set up entering animation
        $next
            .css('transform', direction === 'next' ? 'translateX(100%)' : 'translateX(-100%)')
            .css('transition', 'none')
            .addClass('active')
            .offset(); // Force reflow

        // Trigger animations
        setTimeout(() => {
            $next.css({
                'transform': 'translateX(0)',
                'transition': 'all 0.6s ease-in-out'
            });

            $current.one('transitionend', function() {
                $(this).removeClass('exiting');
                isAnimating = false;
            });

            currentSlide = index;
            updateSideSlides();
        }, 10);

        resetAutoplay();
    }

    function resetAutoplay() {
        clearInterval(autoplayInterval);
        startAutoplay();
    }

    function startAutoplay() {
        autoplayInterval = setInterval(function() {
            if (!isAnimating) {
                showSlide((currentSlide + 1) % totalSlides, 'next');
            }
        }, 5000);
    }

    if (totalSlides > 1) {
        initializeCarousel();
        startAutoplay();
        $('#carouselNext').on('click', function() {
            showSlide((currentSlide + 1) % totalSlides, 'next');
        });
        $('#carouselPrev').on('click', function() {
            showSlide((currentSlide - 1 + totalSlides) % totalSlides, 'prev');
        });
    } else {
        $('#carouselNext').hide();
        $('#carouselPrev').hide();
    }

});

